<template>
  <div>
    <!--タイトル-->
    <header id="header">
      <Header title-image="static/images/common/logo-question.svg" can-back-flag="0"></Header>
    </header>

    <!--結果-->
    <div id="wrapper">
      <div class="content">
        <div class="result-box perfect-box">
            <h3 class="ttl">結果</h3>
        </div>

        <div class="perfect-img">
						<img src="static/images/question/obj_perfect.svg">
				</div>
        
        <!--
        <div class="perfectWrap">
            <div class="roundWrap">
                <svg version="1.1" id="anim_round" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                    x="0px" y="0px" width="300px" height="300px" viewBox="0 0 1000 500" enable-background="new 0 0 1000 500"
                    xml:space="preserve" style="">
                    <path fill="none" stroke="#ff8f80" stroke-width="51.4098" stroke-miterlimit="10"
                        d="M276.5,250.112A224,224 0,1,1 724.5,250.112A224,224 0,1,1 276.5,250.112" class="round"></path>
                </svg>
            </div>
            
            <div class="txt_perfectWrap">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 160.45 31.69">
                    <g>
                        <path class="cls-1"
                            d="M0,31A30.86,30.86,0,0,0,.31,26V5.32A34.48,34.48,0,0,0,0,.38C1.65.46,2.83.5,4.86.5h8c3.71,0,6.31.88,8.15,2.71A9,9,0,0,1,23.38,9.8a9.83,9.83,0,0,1-2.56,7c-1.88,1.87-4.48,2.75-8.15,2.75H5.36V26a31,31,0,0,0,.3,5ZM12.67,15.19c3.52,0,5.43-1.87,5.43-5.24a5.16,5.16,0,0,0-1.26-3.67C16,5.32,14.7,4.9,12.67,4.9H5.36V15.19Z" />
                        <path class="cls-1"
                            d="M30.81,21.24a7.13,7.13,0,0,0,1.41,4.29,6.44,6.44,0,0,0,9.38.22,5.55,5.55,0,0,0,1.11-2l4.51,1.46a10.7,10.7,0,0,1-2.33,3.52,10.88,10.88,0,0,1-7.89,3c-6.77,0-11-4.52-11-11.68S30.19,8.3,36.74,8.3c4.47,0,8,2.22,9.53,6a16,16,0,0,1,1.11,5.82c0,.07,0,.19.07,1.07Zm11.67-3.79a6,6,0,0,0-1.69-3.67,5.42,5.42,0,0,0-4.13-1.53c-3,0-5.17,2-5.74,5.2Z" />
                        <path class="cls-1"
                            d="M65.94,13.81a11.78,11.78,0,0,0-3.41-.61,5.45,5.45,0,0,0-4.44,1.88,6.14,6.14,0,0,0-1.57,3.82V26a40.55,40.55,0,0,0,.27,5H51.32a42.43,42.43,0,0,0,.26-5V14a30.37,30.37,0,0,0-.26-5h5.2v3.6c1.38-2.72,3.75-4,7.2-4A20.4,20.4,0,0,1,67.27,9Z" />
                        <path class="cls-1"
                            d="M71.71,13a26.4,26.4,0,0,0-3.63.23V8.76A24.06,24.06,0,0,0,71.67,9h1.57V7c0-4.74,2.41-7,7.62-7A13.9,13.9,0,0,1,85.6.76l-1,4a6.32,6.32,0,0,0-3.4-.91c-2.22,0-3,.91-3,3.55V9H80a40,40,0,0,0,4.32-.23v4.48A33.42,33.42,0,0,0,80.06,13H78.18V26a38,38,0,0,0,.27,5H73a41.53,41.53,0,0,0,.26-5V13Z" />
                        <path class="cls-1"
                            d="M92.26,21.24a7.13,7.13,0,0,0,1.42,4.29,6.43,6.43,0,0,0,9.37.22,5.4,5.4,0,0,0,1.11-2l4.52,1.46a10.7,10.7,0,0,1-2.34,3.52,10.86,10.86,0,0,1-7.88,3C91.69,31.69,87.4,27.17,87.4,20S91.65,8.3,98.19,8.3c4.48,0,8,2.22,9.53,6a15.62,15.62,0,0,1,1.11,5.82c0,.07,0,.19.08,1.07Zm11.67-3.79a5.93,5.93,0,0,0-1.68-3.67,5.42,5.42,0,0,0-4.13-1.53c-3,0-5.17,2-5.74,5.2Z" />
                        <path class="cls-1"
                            d="M128,16.34A6.75,6.75,0,0,0,126.78,14a4.81,4.81,0,0,0-3.94-1.76c-3.75,0-6.09,2.94-6.09,7.69s2.37,7.73,6.24,7.73a5.15,5.15,0,0,0,4.4-2.14,5.3,5.3,0,0,0,.77-1.92l4.74,1a10.56,10.56,0,0,1-1.61,3.25c-1.83,2.53-4.78,3.87-8.41,3.87-6.74,0-11.1-4.56-11.1-11.64A12.42,12.42,0,0,1,115,11.21a10.49,10.49,0,0,1,7.69-2.91,9.89,9.89,0,0,1,8.57,4.14,12.13,12.13,0,0,1,1.34,2.79Z" />
                        <path class="cls-1"
                            d="M144.65,3.1a43,43,0,0,0-.27,4.71V9H146a22,22,0,0,0,3.86-.23v4.52a21.2,21.2,0,0,0-3.75-.23h-1.72V24.91c0,1.88.69,2.57,2.53,2.57a5,5,0,0,0,2.79-.85l.69,4.06a12,12,0,0,1-4.78.81c-4.4,0-6.17-1.57-6.17-5.59V13.05H138a19.52,19.52,0,0,0-3.41.23V8.76A17.73,17.73,0,0,0,138,9h1.41V7.81a45,45,0,0,0-.26-4.71Z" />
                        <path class="cls-1"
                            d="M155.1,22.58c0-.81.07-1.19.07-1.65s0-.42-.11-2.75l-.54-13c-.07-1.69-.19-3.6-.34-4.67h6.27c-.11,1-.26,3-.34,4.67l-.54,13c-.07,2.26-.07,2.26-.07,2.79a15,15,0,0,0,.07,1.61ZM154.56,31V25.72h5.55V31Z" />
                    </g>
                </svg>
            </div>

        </div>
        -->
      </div>  
    </div>

    <footer id="footer">
        <div class="footer-box">
            <div class="question-result-perfect">
                <div class="text-perfect"><img src="static/images/common/text/text-perfect.svg" alt="全問正解!"></div>
            </div>
            <div class="question-answer-footer">
                <div class="box-l">
                    <button type="button" class="btn btn-unit-l" data-remodal-target="confirmModal2"><img src="static/images/common/btn/btn-unit-l.svg" alt="単元選択へ"></button>
                </div>
                <div class="box-r">
                    <button type="button" class="btn btn-top" data-remodal-target="confirmModal"><img src="static/images/common/btn/btn-top.svg" alt="トップ画面へ"></button>
                </div>
            </div>
        </div>
    </footer>

  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Header from '@/components/modules/Header'
import cmd from '@/common/Command'

export default {
  data: function () {
    return {
      selectedQuestion: "",
      selectedAnswer: "",
    }
  },
  mounted: function () {
    $("body").removeClass()
    $("body").addClass("page-low")
    $("body").addClass("cat-question")
    $("body").addClass("page-question-result")    
    cmd.adjustStyle()
/*
    $('.txt_perfectWrap').on('animationend', function () {
        $(this).css('opacity', '1');
    });
*/
  },
  methods: {
    ...mapActions('QuestionModule', {
    }),
    linkAction (e) {
      var element = e.currentTarget
      var id = element.getAttribute('id')
      //alert(id)

      var self = this
      $.each(this.ngTitle, function(idx, row){
        if (row.id == id) {
          self.question = row.question
          self.answer = row.answer
          return false
        }
      })
      
      $('#detailPopup').modal()
    },
    closePopup (e) {
      $('#detailPopup').modal('hide')
    }
    
    
  },
  computed: {
    ...mapGetters('QuestionModule', [      
      'totalCount',
      'ngTitle'
    ]),
    question: {
      get () {
        return this.selectedQuestion
      },
      set (value) {
        this.selectedQuestion = value
      }
    },
    answer: {
      get () {
        return this.selectedAnswer
      },
      set (value) {
        this.selectedAnswer = value
      }
    },
  },
  components: {
    Header
  }
}
</script>

<style scoped>
.cls-1 {
    fill: #ff8f80;
}
.perfectWrap {
    margin: -30px auto 0;
    position: relative;
    width: 300px;
    height: 300px;
    overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/QuestionResultPerfect.vue